<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="mt-6 pa-4 d-flex justify-space-between">
          <div class="pa-4">
            <span style="font-size: 24px">รายการสินค้า</span>
          </div>
        </div>
        <div class="pa-2">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="binHeader" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.product_code }}</td>
                <td>{{ dataDetail.item.product_name }}</td>
                <td class="text-left" style="color: red;">{{ format_number(dataDetail.item.quantity) }}</td>
                <td class="text-center" style="color: red">
                  <div class="grid_price">
                    <div class="text-left">
                      <div v-if="dataDetail.item.total_dump !== null">{{ format_price(dataDetail.item.total_dump) }}</div>
                      <div v-else>0</div>
                    </div>
                    <div class="text-left">บาท</div>
                  </div>
                </td>
                <td class="pa-3">
                  <v-btn @click="getDetails(dataDetail.item.product_id)" class="pa-6 grad-success-bg white--text"><v-icon>mdi-magnify</v-icon> ดูรายละเอียด</v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {formatNumber, formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Bin_stock",
  data() {
    return {
      loading_page: false,
      search: null,
      alert_success: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      binHeader: [
        {
          text: 'รหัส',
          value: 'product_code',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'จำนวนสินค้าทิ้ง',
          value: 'quantity',
          fixed: true,
          width: '180px',
        },
        {
          text: 'มูลค่าสินค้าทิ้ง',
          value: 'total_dump',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    format_price: function(value) {
      return formatPrice(value)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/dumps/getdumps')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              this.data_list = res.data.object
            }
          })
    },
    getDetails(id) {
      this.$router.push('/stock/storage/bindetails/' + id)
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_price {
  display: grid;
  grid-template-columns: 55% 45%;
}
</style>
